import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { shareUrl } from './share.js';

/**
 * @param {HTMLElement} container
 */
export function initSingleItemModule(container) {
  const slider = document.querySelector('.js_single_item_picture_slider');
  if (slider) {
    new Swiper(slider, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
        addIcons: false,
      },
    });
  }

  document.querySelectorAll('.js_copy_url').forEach(function (el) {
    el.addEventListener('click', function (event) {
      event.stopPropagation();
      shareUrl(el.dataset.url);
    });
  });
}

// Workaround until showSingleList from single-item.js is in a module
window.initSingleItemModule = initSingleItemModule;
